import type { SessionExecutionSnapshot } from "./execution-session-projection";

export interface TabSessionEntry {
  tabId: string;
  sessionId: string;
}

function snapshotHasRunningExecution(
  snapshot: SessionExecutionSnapshot,
): boolean {
  if (snapshot.runAllState?.isRunning) return true;
  const maps = [
    snapshot.executions,
    snapshot.forExecutions,
    snapshot.contentExecutions,
    snapshot.importExecutions,
    snapshot.useExecutions,
  ];
  return maps.some((entries) =>
    [...entries.values()].some((entry) => entry.status === "running"),
  );
}

export function collectBackgroundRunningTabs(options: {
  activeTabId: string;
  runAllPendingTabIds: ReadonlySet<string>;
  tabSessions: Iterable<TabSessionEntry>;
  sessionExecutionCache: ReadonlyMap<string, SessionExecutionSnapshot>;
}): Set<string> {
  const runningTabs = new Set(options.runAllPendingTabIds);

  for (const { tabId, sessionId } of options.tabSessions) {
    if (tabId === options.activeTabId) continue;
    const snapshot = options.sessionExecutionCache.get(sessionId);
    if (snapshot && snapshotHasRunningExecution(snapshot)) {
      runningTabs.add(tabId);
    }
  }

  return runningTabs;
}

export function equalStringSets(
  left: ReadonlySet<string>,
  right: ReadonlySet<string>,
): boolean {
  return (
    left.size === right.size && [...left].every((value) => right.has(value))
  );
}
